<script setup>
import {ref, computed, watch } from 'vue';
import {useI18n} from 'vue-i18n';
import EnConfirmDialog from 'Components/modals/EnConfirmDialog/EnConfirmDialog';

/**
 * A simple delete dialog.
 */
const props = defineProps({
    /**
     * The text displayed as the header of the dialog.
     */
    title: {
      type: String
    },
    /**
     * The confirm button text.
     */
    confirmButtonText: {
      type: String
    },
    /**
     * The delete dialog's message.
     */
    message: {
      type: String
    },
  });
const modelValue = defineModel('modelValue');
const {t} = useI18n();
const emit = defineEmits(['input', 'update:modelValue']);

const isVisible = ref(modelValue.value);

const messageComputed = computed(() => props.message ?? t('common.dataGrid.deleteText'));
const confirmButtonTextComputed = computed(() => props.confirmButtonText ?? t('common.dataGrid.delete'));
const titleComputed = computed(() => props.title ?? t('common.dataGrid.deleteTitle'));

function confirm() {
      isVisible.value = false;
    }

watch(modelValue, async (newValue) => {
  isVisible.value = newValue;
});
watch(isVisible, async (newValue) => {
  /**
   * Triggers when the value is changed.
   */
  emit('input', newValue);
  emit('update:modelValue', newValue);
});

</script>

<template>
  <en-confirm-dialog
      v-model="isVisible"
      :title="titleComputed"
      :confirm-button-text="confirmButtonTextComputed"
      @confirm="confirm"
      width="35%"
      height="auto"
  >
    <span>
      {{ messageComputed }}
    </span>

    <!-- @slot additional dialog content. -->
    <slot></slot>
  </en-confirm-dialog>
</template>


<style lang="scss" scoped>
</style>